export const MIN_PRODUCT_TO_LOAD = 12;